import { Link } from 'react-router-dom';
import { useDashboard } from '../lib/queries';
import Spinner from '../components/Spinner';

export default function Dashboard() {
  const { data, isLoading, error } = useDashboard();

  if (isLoading) return <Spinner />;
  if (error)
    return (
      <div className="alert alert-danger">
        Erro ao carregar dashboard: {String((error as Error).message)}
      </div>
    );

  const rows = data ?? [];
  const total = rows.reduce((sum, r) => sum + r.total, 0);
  const pending = rows.reduce((sum, r) => sum + r.pending, 0);
  const last24h = rows.reduce((sum, r) => sum + r.last_24h, 0);
  const last7d = rows.reduce((sum, r) => sum + r.last_7d, 0);

  return (
    <div>
      <h1 className="h3 mb-4">Dashboard</h1>

      <div className="row g-3 mb-4">
        <Stat label="Total" value={total} icon="bi-people" />
        <Stat label="Pendentes" value={pending} icon="bi-hourglass-split" tone="warning" />
        <Stat label="Últimas 24h" value={last24h} icon="bi-clock-history" tone="info" />
        <Stat label="Últimos 7 dias" value={last7d} icon="bi-calendar-week" />
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 className="h6 mb-0">Por produto</h2>
            <Link to="/waitlist" className="btn btn-sm btn-bb">
              Ver waitlist completa
            </Link>
          </div>

          {rows.length === 0 ? (
            <p className="text-muted small mb-0">
              Nenhum inscrito ainda.
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm align-middle mb-0">
                <thead>
                  <tr>
                    <th>Produto</th>
                    <th className="text-end">Total</th>
                    <th className="text-end">Pendentes</th>
                    <th className="text-end">Notificados</th>
                    <th className="text-end">Confirmados</th>
                    <th className="text-end">Saíram</th>
                    <th className="text-end">24h</th>
                    <th className="text-end">7d</th>
                    <th className="text-end">30d</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.product}>
                      <td>
                        <span className="badge bg-light text-dark border">
                          {r.product}
                        </span>
                      </td>
                      <td className="text-end fw-semibold">{r.total}</td>
                      <td className="text-end">{r.pending}</td>
                      <td className="text-end">{r.notified}</td>
                      <td className="text-end text-success">{r.confirmed}</td>
                      <td className="text-end text-muted">{r.unsubscribed}</td>
                      <td className="text-end">{r.last_24h}</td>
                      <td className="text-end">{r.last_7d}</td>
                      <td className="text-end">{r.last_30d}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Stat({
  label,
  value,
  icon,
  tone,
}: {
  label: string;
  value: number;
  icon: string;
  tone?: 'warning' | 'info';
}) {
  const toneClass =
    tone === 'warning'
      ? 'text-warning'
      : tone === 'info'
      ? 'text-info'
      : 'text-success';
  return (
    <div className="col-6 col-md-3">
      <div className="card shadow-sm h-100">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            <span className="small text-muted">{label}</span>
            <i className={`bi ${icon} ${toneClass}`} />
          </div>
          <div className="display-6 fw-semibold mt-1">{value}</div>
        </div>
      </div>
    </div>
  );
}
